import { useEffect } from "react";
import { useMap } from "react-leaflet";

/**
 * 地図の中心座標を取得して親コンポーネントに渡すコンポーネント
 */
interface MapCenterTrackerProps {
  onCenterChange: (lat: number, lon: number) => void;
}

export const MapCenterTracker = ({ onCenterChange }: MapCenterTrackerProps) => {
  const map = useMap();

  useEffect(() => {
    const updateCenter = () => {
      const center = map.getCenter();
      onCenterChange(center.lat, center.lng);
    };

    // 初期位置を設定
    updateCenter();

    // 地図の移動・ズーム時に中心座標を更新
    map.on("moveend", updateCenter);
    map.on("zoomend", updateCenter);

    return () => {
      map.off("moveend", updateCenter);
      map.off("zoomend", updateCenter);
    };
  }, [map, onCenterChange]);

  return null;
};
